<template>
    <div class="FM_agentaccountList">
        <!-- 表单搜索部分 -->
        <el-card class="box-card" shadow="hover" v-if="nowlevel==0">
            <el-form :inline="true" :model="withdrawlForm" class="demo-form-inline">
                <el-form-item>
                    <el-select
                        size
                        v-model="withdrawlForm.type"
                        clearable
                        placeholder="请选择入账类型"
                    >
                        <el-option label="未分配分润" value="3"></el-option>
                        <el-option label="分润账户税点/手续费" value="0"></el-option>
                        <el-option label="活动账户税点/手续费" value="1"></el-option>
                        <el-option label="市场账户税点/手续费" value="2"></el-option>
                        <el-option label="月结分润" value="4"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-select
                        size
                        v-model="withdrawlForm.intype"
                        clearable
                        placeholder="请选择入账类型"
                    >
                        <el-option label="转入市场账户" value="1"></el-option>
                        <el-option label="提现进入银行卡" value="2"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-select
                        size
                        v-model="withdrawlForm.status"
                        clearable
                        placeholder="请选择入账类型"
                    >
                        <el-option label="已提交" value="1"></el-option>
                        <el-option label="已确认" value="2"></el-option>
                        <el-option label="已到账" value="3"></el-option>
                        <el-option label="已拒绝" value="4"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button
                        size="medium"
                        type="primary"
                        icon="el-icon-search"
                        style="font-size: 12px;"
                        @click="onSearch(withdrawlForm)"
                    >查询</el-button>
                </el-form-item>
            </el-form>
        </el-card>
        <!-- 平台表格部分 -->
        <el-card class="box-card" style="margin-top: 20px;" shadow="hover" v-if="nowlevel==0">
            <el-table
                :data="shWithdrawalTable"
                size="mini"
                border
                style="width: 100%"
            >
                <!-- id -->
                <el-table-column
                    header-align="center"
                    align="center"
                    fixed
                    type="index"
                    label="ID"
                    min-width="50"
                ></el-table-column>
                <!-- 机构 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="agent_name"
                    label="机构"
                    min-width="200"
                ></el-table-column>
                <!-- 账户类型 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="intype"
                    label="账户类型"
                    min-width="120"
                ></el-table-column>
                <!-- 渠道 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="type_name"
                    label="渠道"
                    min-width="150"
                ></el-table-column>
                <!-- 详情 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="detail"
                    label="详情"
                    min-width="250"
                ></el-table-column>
                <!-- 金额 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="money"
                    label="金额"
                    min-width="100"
                ></el-table-column>
                <!-- 金额 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="true_amount"
                    label="实际到账"
                    min-width="100"
                ></el-table-column>
                <!-- 到账银行 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="bank_name"
                    label="到账银行"
                    min-width="150"
                ></el-table-column>
                <!-- 户名 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="bank_acc_name"
                    label="户名"
                    min-width="80"
                ></el-table-column>
                <!-- 账号 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="bank_acc_no"
                    label="账号"
                    min-width="100"
                ></el-table-column>
                <!-- 当前状态 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="status_name"
                    label="当前状态"
                    min-width="100"
                ></el-table-column>
                <!-- 提现时间 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="create_time"
                    label="提现时间"
                    min-width="150"
                ></el-table-column>
                <!-- 审核时间 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="pass_time"
                    label="到账时间"
                    min-width="150"
                ></el-table-column>
                <!-- 操作 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    fixed="right"
                    label="操作"
                    min-width="100"
                >
                    <template slot-scope="scope">
                        <el-button v-if="scope.row.status==1"
                            type="text"
                            size="small"
                            slot="reference"
                            :loading="subloading"
                            @click="pass(scope.row,1)"
                        >通过</el-button>
                        <el-button v-if="scope.row.status==1"
                            type="text"
                            size="small"
                            slot="reference"
                            :loading="subloading"
                            @click="pass(scope.row,2)"
                        >拒绝</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页部分 -->
            <paginations
                :currentPage="page.currentPage"
                :pageSize="page.pageSize"
                :total="page.total"
                @watchCurrent="getCurrent"
                @watchPageSize="getPageSize"
            ></paginations>
        </el-card>

        <!-- 主机构部分 -->
        <el-card class="box-card" shadow="hover" v-if="nowlevel>0">
            <el-form :inline="true" class="demo-form-inline">
                <el-form-item>
                    <el-button
                        size="medium"
                        type="primary"
                        icon="el-icon-search"
                        style="font-size: 12px;"
                        @click="toList()"
                    >提现列表</el-button>
                </el-form-item>
            </el-form>
        </el-card>
        <!-- 主机构账户 --> 
        <el-card class="box-card" v-if="nowlevel>0">
            <!-- 活动账户 -->
            <el-row>
                <!-- 主机构 -->
                <el-col  style="width:23%">
                    <el-card shadow="hover" style="background-color: beige;">
                        <div slot="header" style="text-align: center;">
                            <span style="font-size:12px;font-weight:700">未分配分润</span>
                        </div>
                        <div class="price" >
                            <span>¥{{balancetotal.zero.my_balance}}</span>
                        </div>
                        <div class="bottom" >
                            <el-button style="width: 50%;height: 28px;line-height: 0;"
                                type="danger"
                                class="button"
                                size="medium"
                                @click="zeroTOtwowithdrawl(balancetotal.zero.my_balance,3)"
                            >提现</el-button>
                            <el-button style="width:50%;height: 28px;line-height: 0;"
                                type="success"
                                class="button"
                                size="medium"
                                @click="zeroTOtwo(balancetotal.zero.my_balance,3)"
                            >转入市场账户</el-button>
                        </div>
                    </el-card>
                </el-col>
                <!-- 平台/主机构信息说明 -->
                <el-col style="width:23%;margin-left:2%;">
                    <el-card shadow="hover" style="background-color: beige;">
                        <div slot="header" style="text-align: center;">
                            <span style="font-size:13px;font-weight:700">分润账户税点及手续费</span>
                        </div>
                        <div class="price">
                            <span>¥{{balancetotal.zero.fee}}</span>
                        </div>
                        <div class="bottom">
                            <el-button style="width: 50%;height: 28px;line-height: 0;"
                                type="danger"
                                class="button"
                                size="medium"
                                @click="zeroTOtwowithdrawl(balancetotal.zero.fee,0)"
                            >提现</el-button>
                            <el-button style="width: 50%;height: 28px;line-height: 0;"
                                type="success"
                                class="button"
                                size="medium"
                                @click="zeroTOtwo(balancetotal.zero.fee,0)"
                            >转入市场账户</el-button>
                        </div>
                    </el-card>
                </el-col>
                <el-col style="width:23%;margin-left:2%;">
                    <el-card shadow="hover" style="background-color: beige;">
                        <div slot="header" style="text-align: center;">
                            <span style="font-size:13px;font-weight:700">活动账户税点及手续费</span>
                        </div>
                        <div class="price">
                            <span>¥{{balancetotal.one.fee}}</span>
                        </div>
                        <div class="bottom">
                            <el-button style="width: 50%;height: 28px;line-height: 0;"
                                type="danger"
                                class="button"
                                size="medium"
                                @click="zeroTOtwowithdrawl(balancetotal.one.fee,1)"
                            >提现</el-button>
                            <el-button style="width:50%;height: 28px;line-height: 0;"
                                type="success"
                                class="button"
                                size="medium"
                                @click="zeroTOtwo(balancetotal.one.fee,1)"
                            >转入市场账户</el-button>
                        </div>
                    </el-card>
                </el-col>
                <el-col style="width:23%;margin-left:2%;">
                    <el-card shadow="hover" style="background-color: beige;">
                        <div slot="header" style="text-align: center;">
                            <span style="font-size:13px;font-weight:700">市场账户税点及手续费</span>
                        </div>
                        <div class="price">
                            <span>¥{{balancetotal.two.fee}}</span>
                        </div>
                        <div class="bottom">
                            <el-button style="width: 50%;height: 28px;line-height: 0;"
                                type="danger"
                                class="button"
                                size="medium"
                                @click="zeroTOtwowithdrawl(balancetotal.two.fee,2)"
                            >提现</el-button>
                            <el-button style="width: 50%;height: 28px;line-height: 0;"
                                type="success"
                                class="button"
                                size="medium"
                                @click="zeroTOtwo(balancetotal.two.fee,2)"
                            >转入市场账户</el-button>
                        </div>
                    </el-card>
                </el-col>
            </el-row>
        </el-card>
        <!-- 主机构月结分润表格 -->
        <el-card class="box-card" style="margin-top: 20px;" shadow="hover" v-if="nowlevel>0">
            <el-table
                :data="WTable"
                size="mini"
                border
                style="width: 100%"
                v-loading="loading"
            >
                <!-- 品牌 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="brand"
                    label="终端类型"
                    min-width="80"
                ></el-table-column>
                <!-- 年 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="year"
                    label="年"
                    min-width="80"
                ></el-table-column>
                <!-- 月 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="month"
                    label="月"
                    min-width="80"
                ></el-table-column>
                <!-- 交易类型 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="pay_type_name"
                    label="交易类型"
                    min-width="100"
                >
                </el-table-column>
                <!-- 总交易 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="all_money"
                    label="总交易金额"
                    min-width="100"
                >
                </el-table-column>
                <!-- 费率 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="fee_rate"
                    label="费率(‰)"
                    min-width="80"
                ></el-table-column>
                <!-- 可提现金额 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="money"
                    label="可提现金额"
                    min-width="120"
                ></el-table-column>
                <!-- 操作 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    fixed="right"
                    label="操作"
                    min-width="150"
                >
                    <template slot-scope="scope">
                        <!-- 撤销验证 -->
                        <el-button
                            type="text"
                            size="small"
                            slot="reference"
                            @click="monthwithdrawl(scope.row)"
                        >提现</el-button>
                        <el-button
                            type="text"
                            size="small"
                            slot="reference"
                            @click="monthTOtwo(scope.row,4)"
                        >转入市场账户</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页部分 -->
            <paginations
                :currentPage="page.currentPage"
                :pageSize="page.pageSize"
                :total="page.total"
                @watchCurrent="getCurrent"
                @watchPageSize="getPageSize"
            ></paginations>
        </el-card>
        <!-- 转入2账户 -->
        <el-dialog :visible="topUpIsShow" @close="handleClose" width="430px" v-if="nowlevel>0">
            <el-card class="box-card" shadow="hover">
                <el-form label-position="left" label-width="100px" :model="topUpForm">
                    <el-form-item label="充值金额">
                        <el-input placeholder="请输入充值金额" v-model="topUpForm.money" type= "number">
                            <span slot="suffix" style="font-size:12px">元</span>
                        </el-input>
                    </el-form-item>
                    <div style="margin-top:20px;text-align: center;">
                        <el-button
                            type="primary"
                            size="medium"
                            @click="submit(topUpForm)"
                            :loading="submitLoading"
                            style="font-size:12px"
                        >确定</el-button>
                        <el-button
                            type="primary"
                            size="medium"
                            @click="topUpIsShow=false"
                            style="font-size:12px"
                        >取消</el-button>
                    </div>
                </el-form>
            </el-card>
        </el-dialog>
        <!-- 提现弹出 -->
        <el-dialog :visible="infoIsShow" @close="handleClose" :close-on-click-modal="false">
            <el-card class="box-card" shadow="hover">
                <div class="title">银行信息</div>
                <el-row :gutter="20">
                    <el-col :span="24">
                        <span class="labels">持卡人姓名：</span>
                        <span>{{bankdata.account_name}}</span>
                    </el-col>
                    <el-col :span="24">
                        <span class="labels">银行名称：</span>
                        <span>{{bankdata.bank_name}}</span>
                    </el-col>
                    <el-col :span="24">
                        <span class="labels">银行卡号：</span>
                        <span>{{bankdata.bank_code}}</span>
                    </el-col>
                    <el-col :span="24">
                        <span class="labels">预留手机号：</span>
                        <span>{{bankdata.phone}}</span>
                    </el-col>
                    <el-col :span="24">
                        <span class="labels">开户所在地：</span>
                        <span>{{bankdata.bank_prov}}-{{bankdata.bank_city}}</span>
                    </el-col>
                    <el-col :span="24">
                        <span class="labels">开户支行：</span>
                        <span>{{bankdata.branch_bank}}</span>
                    </el-col>
                    <el-col :span="24">
                        <span class="labels">联行号：</span>
                        <span>{{bankdata.line_num}}</span>
                    </el-col>
                </el-row>
                <el-form
                    :model="auditForm"
                    label-position="top"
                    label-width="80px"
                >
                    <div class="title">提现金额<span style="color:red">[单位:元]</span></div>
                    <el-input v-model="auditForm.money" placeholder="请输入金额" style="width: 130px;" type="number"></el-input>
                    <el-button
                        @click="max_number()"
                        type="primary"
                        size="medium"
                        style="font-size:12px"
                    >全部提现</el-button>
                    <div class="title" style="margin-top:20px">选择银行卡</div>
                    <el-select
                    size="medium"
                    v-model="auditForm.bank_id"
                    style="width:405px"
                    placeholder="请选择提现银行卡"
                    >
                        <el-option
                            v-for="(item,index) in selectbank"
                            :key="index"
                            :label="item.bank_name+' | '+item.bank_code"
                            :value="item.bank_id"
                        ></el-option>
                    </el-select>
                </el-form>
                <div style="margin-top:20px">
                    <el-button
                        @click="audit_submit()"
                        type="primary"
                        size="medium"
                        style="font-size:12px"
                        :loading="subloading"
                    >确 定</el-button>
                </div>
            </el-card>
        </el-dialog>
    </div>
</template>
<script>
import paginations from '../../../components/pagination/paginations';
import infoAudit from './FM_agentwithdrawalInfo';
export default {
    name: "FM_agentwithDrawal",
    data() {
        return {
            nowlevel: sessionStorage.getItem('level'), //等级
            balancetotal: {},//账户余额
            topUpIsShow: false, //充值
            submitLoading: false,
            subloading: false,
            infoIsShow: false, //审核弹窗
            loading: true,
            selectbank:{},
            topUpForm: { //提交转入市场账户表单
                money: 0,
                type: 0,
                map: [],
            },
            bankdata:{
                bank_name:"",
                bank_code:"",
                phone:"",
                bank_prov:"",
                bank_city:"",
                branch_bank:"",
                line_num:"",
            },
            auditForm: {//提现提交表单
                bank_acc_name:"",
                bank_acc_no:"",
                bank_acc_type:"",
                bank_name:"",
                bank_id: 0,
                brand_id: 0,
                pay_type: 0,
                money: 0,
                year: "0",
                month: "0",
            },
            withdrawlForm: {//平台搜索框
                type: '',
                intype: '',
                status: '',
                page: 1,
                limit: 10
            },
            shWithdrawalTable:[],
            WTable:[],
            allmoney:0,
            page: {
                currentPage: 1, //当前页码
                pageSize: 10, //条数
                total: 0  //总数
            },
            pages: {
                currentPages: 1, //当前页码
                pageSizes: 10, //条数
                totals: 0  //总数
            },
            agentForm: {
                page: 1,
                limit: 10
            },
        }
    },
    components: {
        paginations,
    },
    mounted() {
        if(sessionStorage.getItem('level')==0){
            this.getDatas();
        }
        if(sessionStorage.getItem('level')==1){
            this.getagentBalance();
            this.getData();
        }
    },
    methods: {
        toList(){
            this.$router.push({path:'/agentwithdrawalLists',query:{}});
        },
        getagentBalance() { //获取余额
            this.$api.post('organization/agent_balance', {}, res => {
                if (res.code == 0) {
                    this.balancetotal = res.data;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        getbanks() { //获取支付方式
            this.$api.post('user/bank_lists_by_user_id', {user_id:sessionStorage.getItem('admin_id')}, res => {
                if (res.code == 0) {
                    this.selectbank = res.data;
                    this.auditForm.bank_id=res.data[0].bank_id;
                    this.auditForm.money=0;
                    this.getbanklists(res.data[0].id);
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        getbanklists(bankId) { //获取支付方式
            this.$api.post('user/bank_info', { bank_id: bankId }, res => { //初始化
                if (res.code == 0) {
                    this.bankdata = res.data[0];
                    this.auditForm.bank_acc_name=res.data[0].account_name;
                    this.auditForm.bank_acc_no=res.data[0].bank_code;
                    this.auditForm.bank_acc_type=res.data[0].account_type;
                    this.auditForm.bank_name=res.data[0].bank_name;
                } else {
                    this.$message.error(res.msg);
                }
            })
        },
        //主机构分润列表
        getData() {
            this.$api.post("organization/agentWithdrawmonthList", this.agentForm, res => {
                if (res.code == 0) {
                    let data = res.data;
                    this.page.total = data.count; //总数
                    this.WTable = data.list;
                } else {
                    this.$message.error(res.msg);
                }
                //渲染结束后取消加载
                this.loading = false;
            })
        },
        //分页
        getCurrent(page) {
            // 获取当前页修改的值
            this.page.currentPage = page;
            this.agentForm.page = this.page.currentPage;
            this.agentForm.limit = this.page.pageSize;
            this.withdrawlForm.page = this.page.currentPage;
            this.withdrawlForm.limit = this.page.pageSize;
            if(sessionStorage.getItem('level')==0){
                this.getDatas();
            }
            if(sessionStorage.getItem('level')==1){
                this.getData();
            }
        },
        getPageSize(limit) {
            this.page.currentPage = 1; //重置分页
            // 获取条数发生改变的值
            this.page.pageSize = limit;
            this.agentForm.page = this.page.currentPage;
            this.agentForm.limit = limit;
            this.withdrawlForm.page = this.page.currentPage;
            this.withdrawlForm.limit = limit;
            if(sessionStorage.getItem('level')==0){
                this.getDatas();
            }
            if(sessionStorage.getItem('level')==1){
                this.getData();
            }
        },
        onSearch(){
            this.getDatas();
        },
        getDatas() {
            this.$api.post("organization/agentWithdrawLog", this.withdrawlForm, res => {
                if (res.code == 0) {
                    let data = res.data;
                    this.page.total = data.count; //总数
                    this.shWithdrawalTable = data.list;
                } else {
                    this.$message.error(res.msg);
                }
            })
        },
        topUpClose() { //关闭充值弹窗
            this.topUpIsShow = false;
            this.submitLoading=false;
        },
        handleClose(){
            this.topUpIsShow = false;
            this.infoIsShow = false;
            this.submitLoading=false;
            this.subLoading=false;
        },
        zeroTOtwo(money,type) {
            this.topUpIsShow = true;
            this.topUpForm.type = type;
            this.topUpForm.money=money;
            this.allmoney=money;
        },
        monthTOtwo(row,type) {
            this.topUpIsShow = true;
            this.topUpForm.type = type;
            this.topUpForm.money=row.money;
            this.topUpForm.map=row;
            this.allmoney=row.money;
        },
        zeroTOtwowithdrawl(money,type){
            this.infoIsShow = true;
            this.getbanks();
            this.auditForm.type = type;
            this.auditForm.money=money;
            this.allmoney=money;
        },
        // 月结提现
        monthwithdrawl(row){
            // console.log(row)
            this.getbanks();
            this.auditForm.type = 4;
            this.auditForm.year=row.year;
            this.auditForm.month=row.month;
            this.auditForm.brand_id=row.brand_id;
            this.auditForm.pay_type=row.pay_type;
            this.allmoney=row.money;
            this.infoIsShow = true;
        },
        max_number() { //提交
            this.auditForm.money=this.allmoney;
        },
        submit(topUpForm) {
            this.submitLoading=true;
            console.log(this.allmoney)
            console.log(topUpForm.money)
            if(this.allmoney<topUpForm.money){
                this.$message.error("余额不足");
                this.submitLoading=false;
            }else{
                this.$api.post('organization/toTwoApply', topUpForm, res => {
                    if (res.code == 0) {
                        let that = this;
                        that.getagentBalance();
                        that.getData();
                        this.$message({
                            type: 'success',
                            message: res.msg,
                            duration: 1000,
                            onClose() {
                                that.topUpClose();
                            }
                        });
                    } else {
                        this.$message.error(res.msg);
                        this.submitLoading=false;
                    }
                })
            }
        },
        audit_submit() { //提交
            this.subloading=true;
            if(this.allmoney<this.auditForm.money){
                this.$message.error("余额不足");
                this.subloading=false;
            }else{
                this.$api.post('organization/agent_withdraw_audit', this.auditForm, res => {
                    if (res.code == 0) {
                        let that = this;
                        that.getagentBalance();
                        that.getData();
                        this.subloading=false;
                        this.$message({
                            type: 'success',
                            message: res.msg,
                            duration: 1000,
                            onClose() {
                                that.handleClose();
                            }
                        });
                    } else {
                        this.$message.error(res.msg);
                        this.subloading=false;
                    }
                })
            }
        },
        pass(row,type) { //通过
            this.subloading=false;
            if(type==1){
                var type_message='是否通过？';
            }
            if(type==2){
                var type_message='是否拒绝？';
            }
            this.$confirm(type_message, '提 示', {
                type: 'warning',
                distinguishCancelAndClose: true,
                confirmButtonText: '确 定',
                cancelButtonText: '取 消'
            }).then(() => {
                this.$api.post('organization/agent_withdraw_pass', {id:row.id,type:type}, res => {
                    if (res.code == 0) {
                        let that = this;
                        this.subloading=false;
                        this.$message({
                            type: 'success',
                            message: res.msg,
                            duration: 1000,
                            onClose() {
                                that.handleClose();
                            }
                        });
                        this.getDatas();
                    } else {
                        this.$message.error(res.msg);
                        this.subloading=false;
                    }
                })
            }).catch(() => {
                this.subloading=false;
            })
        },
    }
};
</script>

<style lang="scss" scope>
.FM_agentaccountList {
    font-size: 12px;
    .price {
        text-align: center;
        font-size: 30px;
        font-weight: 700;
        height: 50px;
        height: 100px;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
    .el-card__header{
        background-color: bisque;
    }
    .el-col {
        margin: 10px 0;
    }
    .rightTitle {
        margin: 20px;
        :nth-child(1) {
            font-weight: 700;
        }
    }

    .bottom {
        .el-button {
            font-size: 12px;
        }
        display: flex;
        justify-content: flex-end;
    }
    //     .el-input__inner {
    //     border: none;
    //     text-align: center;
    //     font-size: 12px;
    // }
    .el-form-item {
        margin-bottom: 5px;
    }
    .el-switch__label *,
    .el-button--text {
        font-size: 12px;
    }
    // .tableDiv {
        // overflow-x: scroll;
    // }
    .rateTable {
        // margin-top: 20px;
        border: 1px solid #ebeef5;
        display: table;
        border-collapse: separate;
        border-spacing: 2px;
        width: -webkit-fill-available;
        // width: 2000px;
        thead {
            color: #909399;
            font-weight: 500;
            th {
                border-bottom: 1px solid #ebeef5;
                border-right: 1px solid #ebeef5;
                // overflow: auto;
                padding: 12px 0;
                min-width: 150px;
                -webkit-box-sizing: border-box;
                box-sizing: border-box;
                text-overflow: ellipsis;
                vertical-align: middle;
                position: relative;
                text-align: center;
                font-size: 12px;
            }
        }
        tbody {
            display: table-row-group;
            vertical-align: middle;
            border-color: inherit;
            // :nth-last-child(1) td {
                // border-bottom: none;
            // }
            td {
                transition: background-color 0.25s ease;
                border-right: 1px solid #ebeef5;
                // border-bottom: 1px solid #ebeef5;
                // border-left: 1px solid #ebeef5;
                border-top: 1px solid #ebeef5;
                // padding: 12px 0;
                min-width: 200px;
                -webkit-box-sizing: border-box;
                box-sizing: border-box;
                text-overflow: ellipsis;
                vertical-align: middle;
                position: relative;
                text-align: center;
                font-size: 12px;
            }
            // tr {
            //     :nth-last-child(1) {
            //         border-right: none;
            //     }
            // }
        }
        td,
        th {
            display: table-cell;
            vertical-align: inherit;
        }
    }
    .el-dialog {
        display: flex;
        flex-direction: column;
        margin: 0 !important;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        /*height:600px;*/
        max-height: calc(100% - 30px);
        max-width: calc(100% - 30px);
    }
    .el-dialog .el-dialog__body {
        flex: 1;
        overflow: auto;
    }
}
</style>
